// CMS entries for dfsweb-rewamp-homescreen override these at runtime.
// Legacy bundle had no Hindi for these sentence keys — hi copy is inferred, needs a translator.
export const en = {
  "AI_ASSISTANT.TITLE": "Bihar Krishi AI — Your AI Farming Assistant",
  "AI_ASSISTANT.WELCOME_DESCRIPTION":
    "Ask questions in Hindi or English about crop care, pest management, weather impact, and scheme eligibility, with guidance based on ICAR and Bihar agricultural extension services.",
  "CATEGORY_SECTION.COMING_SOON_NOTICE": "More categories coming soon.",
  "CROP_ADVISORY.EMPTY_STATE_MESSAGE": "No advisory information available for this crop.",
  "FAQ_PANEL.EYEBROW": "— HAVE QUESTIONS",
  "FAQ_PANEL.TITLE": "Frequently Asked Questions",
  "FAQ_PANEL.VIEW_ALL": "View all",
  "FAQ_PANEL.TABS_LABEL": "FAQ categories",
  "FAQ_PANEL.EMPTY": "No FAQs in this category yet.",
  "FAQ_PANEL.ERROR": "FAQs could not be loaded.",
  "FAQ_PANEL.RETRY": "Retry",
  "UPDATES.LIVE": "LIVE",
};

export const hi = {
  "AI_ASSISTANT.TITLE": "बिहार कृषि AI — आपका AI कृषि सहायक",
  "AI_ASSISTANT.WELCOME_DESCRIPTION":
    "फसल देखभाल, कीट प्रबंधन, मौसम के प्रभाव और योजना पात्रता के बारे में हिंदी या अंग्रेज़ी में प्रश्न पूछें — ICAR और बिहार कृषि विस्तार सेवाओं पर आधारित मार्गदर्शन के साथ।",
  "CATEGORY_SECTION.COMING_SOON_NOTICE": "और श्रेणियाँ जल्द आ रही हैं।",
  "CROP_ADVISORY.EMPTY_STATE_MESSAGE": "इस फसल के लिए कोई सलाह जानकारी उपलब्ध नहीं है।",
  // FAQ_PANEL.* copied verbatim from src/locales/hindi/translation.js (not inferred).
  "FAQ_PANEL.EYEBROW": "प्रश्न पूछें",
  "FAQ_PANEL.TITLE": "अक्सर पूछे जाने वाले प्रश्न",
  "FAQ_PANEL.VIEW_ALL": "सभी देखें",
  // inferred, needs translator
  "FAQ_PANEL.TABS_LABEL": "प्रश्न श्रेणियाँ",
  "FAQ_PANEL.EMPTY": "इस श्रेणी में अभी कोई प्रश्न नहीं है।",
  "FAQ_PANEL.ERROR": "प्रश्न लोड नहीं हो सके।",
  "FAQ_PANEL.RETRY": "पुनः प्रयास करें",
  // inferred, needs translator
  "UPDATES.LIVE": "लाइव",
};
